<script>
    import { preventDefault } from 'svelte/legacy';

import {
    modalState, hideModal, showModal
} from "@app/store/modalStore.svelte.js";
import {
    speakerState
} from "@app/store/speakerStore.svelte.js";
import {
    projectState
} from "@app/store/projectStore.svelte.js";
import {
    eventGroupState
} from "@app/store/eventGroupStore.svelte.js";
import {
    historyState, insertHistoryAction, resetHistory
} from "@app/store/historyStore.svelte.js";
import {
    fade
} from "svelte/transition";
import convertToHtml from '@cclib/functions/quill/convertToHtml.js';
import quillClasses from '@cclib/dict/quillClasses.js';
import * as m from '@app/paraglide/messages.js';

let speakerDefaults = JSON.parse(localStorage.getItem("cc-speaker-defaults")) || {};
let prefixChar = $state(speakerDefaults.prefixChar || ""),
    suffixChar = $state(speakerDefaults.suffixChar || ""),
    upperCaseAll = $state(speakerDefaults.upperCaseAll),
    insertInline = $state(speakerDefaults.insertInline),
    speakerName = $state("_USE_EVENT_SPEAKER_OPTION_"),
    alignmentMap = {
        left: false,
        right: "right",
        center: "center"
    };

function insertSpeakerName() {
    if (!speakerName) {
        return;
    }

    let insertText = `${prefixChar}${upperCaseAll ? speakerName.toUpperCase() : speakerName}${suffixChar}`;

    eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
        if (speakerName === "_USE_EVENT_SPEAKER_OPTION_") {
            if (!eventGroupState[projectState.selected].events[eventIndex].speakers[0]) {
                return;
            } else {
                insertText = `${prefixChar}${upperCaseAll ? eventGroupState[projectState.selected].events[eventIndex].speakers[0].name.toUpperCase() : eventGroupState[projectState.selected].events[eventIndex].speakers[0].name}${suffixChar}`;
            }
        }

        if (insertInline){
            eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(<p\b[^>]*>)/, '$1' + insertText);
        } else {
            eventGroupState[projectState.selected].events[eventIndex].text = convertToHtml(insertText, [quillClasses.align[eventGroupState[projectState.selected].events[eventIndex].alignment]]) + eventGroupState[projectState.selected].events[eventIndex].text;
        }
        

        if (count === 0 && window.quillEditor) {
            let delta = window.quillEditor.clipboard.convert({ html: eventGroupState[projectState.selected].events[eventIndex].text });
            window.quillEditor.setContents(delta, "silent");
            window.quillEditor.formatLine(0,9999, 'align', eventGroupState[projectState.selected].events[eventIndex].alignment === 'left' ? '' : eventGroupState[projectState.selected].events[eventIndex].alignment, "silent");
        }
    });

    insertHistoryAction({
        name: "insert speaker name", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    localStorage.setItem("cc-speaker-defaults", JSON.stringify({
        prefixChar: prefixChar,
        suffixChar: suffixChar,
        upperCaseAll: upperCaseAll,
        insertInline: insertInline
    }));

    hideModal();
}
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'insertSpeaker' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="insertSpeakerTitle"
    aria-describedby="insertSpeakerDescription"
    tabindex="-1"
    id="InsertSpeakerModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="insertSpeakerTitle">{m.insert_speaker_title()}</h4>
                <button
                    type="button"
                    class="btn-close"
                    id="closeSpeakerModal"
                    aria-label={m.insert_speaker_close_label()}
                    onclick={hideModal}>
                </button>
            </div>
            <div class="modal-body" id="insertSpeakerDescription">
                <form onsubmit={preventDefault(insertSpeakerName)} aria-label={m.insert_speaker_form_label()}>
                    <div class="mb-3">
                        <label class="form-label" for="SpeakerNameSelect">{m.insert_speaker_name_label()}</label>
                        <!-- svelte-ignore a11y_autofocus -->
                        <select class="form-select" id="SpeakerNameSelect" autofocus bind:value={speakerName}>
                            <option value="_USE_EVENT_SPEAKER_OPTION_">{m.insert_speaker_assigned_option()}</option>
                            {#each speakerState as speaker (speaker.id)}
                            <option>{speaker.name}</option>
                            {/each}
                        </select>
                    </div>
                    <div class="row mb-2">
                        <div class="col">
                            <label class="form-label" for="prefixCharacter">{m.insert_speaker_prefix_label()}</label>
                            <input type="text" class="form-control" id="prefixCharacter" bind:value={prefixChar}>
                        </div>
                        <div class="col">
                            <label class="form-label" for="suffixCharacter">{m.insert_speaker_suffix_label()}</label>
                            <input type="text" class="form-control" id="suffixCharacter" bind:value={suffixChar}>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col">
                            <input type="checkbox" class="form-check-input" id="upperCaseAllName" bind:checked={upperCaseAll}>
                            <label class="form-check-label" for="upperCaseAllName">{m.insert_speaker_uppercase_label()}</label>
                        </div>
                        <div class="col">
                            <input type="checkbox" class="form-check-input" id="insertInlineCheck" bind:checked={insertInline}>
                            <label class="form-check-label" for="insertInlineCheck">{m.insert_speaker_inline_label()}</label>
                        </div>
                    </div>
                    <button class="btn btn-outline-dark float-end ms-2" 
                            id="manageSpeakersBtn"
                            type="button"
                            aria-label={m.insert_speaker_manage_label()}
                            onclick={() => showModal("speakerManager")}>
                        {m.insert_speaker_manage_button()}
                    </button>
                    <button
                        class="btn btn-primary float-end"
                        id="insertSpeakerBtn" 
                        type="submit"
                        aria-disabled={!speakerName}
                        disabled={!speakerName}>
                        {m.insert_speaker_insert_button()}
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
